import { useEmbeddedMode } from "@src/appV2/EmbeddedMode/EmbeddedModeContext";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { useSkillsAssessmentFeatureFlags } from "@src/appV2/SkillsAssessment/api/useSkillsAssessmentFeatureFlags";
import { useSkillsAssessments } from "@src/appV2/SkillsAssessment/api/useSkillsAssessments";
import { SKILLS_ASSESSMENT_BASE_PATH } from "@src/appV2/SkillsAssessment/paths";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { isEmpty } from "lodash";
import { useHistory } from "react-router-dom";

import { useHasActionRequiredForMandatoryRequirements } from "../../Documents/api/useHasActionRequiredForMandatoryRequirements";
import { DOCUMENTS_BASE_PATH_FULL } from "../../Documents/paths";
import { AccountListItem } from "../components/AccountListItem";
import { logAccountPageMenuItemTapped } from "../utils";

export function AccountsPageDocumentsSection() {
  const worker = useDefinedWorker();
  const { userId } = worker;
  const { isEmbedded } = useEmbeddedMode();

  const history = useHistory();

  const { skillsAssessmentConfig, isClipboardOrientationEnabled } =
    useSkillsAssessmentFeatureFlags();
  const { data: skillsAssessments, isSuccess: isSuccessSkillsAssessments } = useSkillsAssessments(
    {
      workerId: userId,
      qualificationNames: skillsAssessmentConfig.availableQualificationNames,
    },
    { staleTime: 0 }
  );

  const hasActionRequiredForMandatoryRequirements = useHasActionRequiredForMandatoryRequirements();

  const shouldShowOrientation =
    isClipboardOrientationEnabled && isSuccessSkillsAssessments && !isEmpty(skillsAssessments.data);

  return (
    <>
      {shouldShowOrientation && (
        <AccountListItem
          iconType="introduction-video"
          primaryText="Demo Shift"
          secondaryText={
            <Text variant="caption" color={(theme) => theme.palette.text.secondary}>
              Watch a quick virtual walkthrough before you start booking and earning
            </Text>
          }
          onClick={() => {
            logAccountPageMenuItemTapped("Skills Assessment");
            history.push(SKILLS_ASSESSMENT_BASE_PATH);
          }}
        />
      )}
      {!isEmbedded && (
        <AccountListItem
          iconType="folder"
          primaryText="Documents for Flex Shifts"
          secondaryText={
            <Text
              variant="caption"
              color={(theme) =>
                hasActionRequiredForMandatoryRequirements
                  ? theme.palette.error.main
                  : theme.palette.text.secondary
              }
            >
              {hasActionRequiredForMandatoryRequirements
                ? "Some documents are missing or expired!"
                : "Manage your documents"}
            </Text>
          }
          onClick={() => {
            logAccountPageMenuItemTapped("Documents");
            history.push(DOCUMENTS_BASE_PATH_FULL);
          }}
        />
      )}
    </>
  );
}
